module.exports = __webpack_public_path__ + "img/bitcoin-cash.b2043fc9.png";